import { doc, getFirestore, setDoc } from 'firebase/firestore';

export const formUpdate = async (eventOrKey, store, loading, col, docId, newField = '', documentOverride) => {
	loading = true;
	const updates = documentOverride
		? { ...documentOverride }
		: { ...store?.[col]?.docs?.[docId] };
	delete updates.index;

	if (
		newField !== '' &&
		!Object.keys(store[col]?.docs?.[docId] || {}).includes(
			newField
		)
	) {
		updates[newField] = {
			type: 'TextInput',
			permission: 'Admin',
			translations: {}
		};
	}

	const key = typeof eventOrKey === 'string' ? eventOrKey : eventOrKey?.target?.getAttribute('key');

	if (key) { // deleting a key means we won't have a key
		if (['TextObject', 'Location', 'Function', 'Image', 'Icon'].includes(updates[key]?.type)) {
			if (typeof updates[key].value !== 'object') {
				updates[key].value = {};
				delete updates[key].translations;
			}
		} else {
			if (typeof updates[key]?.value === 'object') {
				updates[key].value = '';
				updates[key].translations = {};
			}
		}
		// let's make sure the description for images are setup
		if (updates[key]?.type === 'Image') {
			if (typeof updates[key].value.description !== 'object') {
				updates[key].value.description = {
					value: '',
					translations: {}
				};
			}
		}
	}

	await setDoc(doc(getFirestore(), `${col}/${docId}`), updates, {
		merge: false
	});

	loading = false;
};
